import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Button } from '../../../../shared/FormStyles';
import Text from '../../../../shared/Text';

const MockProgressBar = ({ color }) => {
  const { t } = useTranslation('campaigns');

  const progressBarData = useSelector(state => state.progressBarData);
  const { completedTiles, incompletedTiles, points } = progressBarData;

  return (
    <ProgressBarContainer>
      <ProgressContent>
        <ProgressContentText variant="subtitle2">
          {t('preview.mockProgressBar.progressBarTitle')}
        </ProgressContentText>
        <Bar>
          <BarCompleted
            color={color}
            width={`${
              completedTiles === 0
                ? completedTiles
                : (completedTiles / incompletedTiles) * 100
            }%`}
          />
        </Bar>
        <Text fontSize="18px" variant="subtitle1" color={color}>
          {`${completedTiles}/${incompletedTiles}`}
        </Text>
      </ProgressContent>
      <ProgressContent>
        <ProgressContentText variant="subtitle2">
          {t('preview.mockProgressBar.progressBarPointLabel')}
        </ProgressContentText>
        <Text fontSize="18px" variant="subtitle1" color={color}>
          {points}
        </Text>
      </ProgressContent>

      <SuggestButton bg="white" color={color} borderColor={color}>
        {t('preview.mockProgressBar.suggestTile')}
      </SuggestButton>
    </ProgressBarContainer>
  );
};

export default MockProgressBar;

const ProgressBarContainer = styled.div`
  cursor: not-allowed;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  margin: 24px;
  opacity: 0.5;
`;

const ProgressContent = styled.div`
  display: flex;
  border-radius: 20px;
  padding: 8px 16px;
  align-items: center;
  gap: 13px;
  box-shadow: 0px 18px 32px ${themeGet('colors.black.5')};
`;

const ProgressContentText = styled(Text)`
  position: relative;
  margin-right: 8px;

  &:after {
    content: '';
    border-right: 1px solid ${themeGet('colors.black.10')};
    position: absolute;
    right: -8px;
    height: 100%;
  }
`;

const Bar = styled.div`
  border-radius: 20px;
  width: 300px;
  background: ${themeGet('colors.black.10')};
  height: 12px;
`;
const BarCompleted = styled(Bar)`
  width: ${({ width }) => width};
  background: ${({ color }) => color};
`;

const SuggestButton = styled(Button)`
  padding: 7px 16px;
  height: 34px;
  display: inline-block;
  white-space: nowrap;
  pointer-events: none;

  &:hover {
    opacity: 0.38;
  }
`;
